import WOW from 'wowjs/dist/wow'
import $ from "jquery"
import { useEffect } from "react"
import { useGetSettingQuery } from '../../../Redux/Apis/siteApi'
import { Link, NavLink } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'

export default function Header(){
    const {data : { name, menu, contacts , logo}} = useGetSettingQuery()

    useEffect(() => {
        new WOW.WOW({
          live: false
        }).init();

        $(window).scroll(function () {
            if ($(this).scrollTop() > 300) {
                $('.sticky-top').addClass('shadow-sm').css('top', '0px');
            } else {
                $('.sticky-top').removeClass('shadow-sm').css('top', '-100px');
            }
        });
      }, [])
      
    return (
        <>
        <div className="container-fluid bg-light p-0">
            <div className="row gx-0 d-none d-lg-flex">
                <div className="col-lg-7 px-5 text-start">
                    {contacts.address && <div className="h-100 d-inline-flex align-items-center py-3 me-4">
                        <small className="fa fa-map-marker-alt text-primary me-2"></small>
                        <small>{contacts.address}</small>
                    </div>}
                </div>
                <div className="col-lg-5 px-5 text-end">
                    {contacts.mobile && <div className="h-100 d-inline-flex align-items-center py-3 me-4 ">
                        <small className="fas fa-phone text-primary me-1"></small>
                        <small><a dir="ltr" href={`tel:${contacts.mobile}`}>{contacts.mobile}</a></small>
                    </div>}
                    <div className="h-100 d-inline-flex align-items-center">
                        {contacts.socials && contacts.socials.map((row,index) =>
                            {
                                if(row.value !== ''){
                                    switch (row.key) {
                                        case 'فیسبوک':
                                            return <a key={index} className="btn btn-sm-square bg-white text-primary me-1" href={row.value}><i className="fab fa-facebook-f"></i></a>
                                        case 'توییتر':
                                            return <a key={index} className="btn btn-sm-square bg-white text-primary me-1" href={row.value}><i className="fab fa-twitter"></i></a>
                                        case 'اینستاگرام':
                                            return <a key={index} className="btn btn-sm-square bg-white text-primary me-1" href={row.value}><i className="fab fa-instagram"></i></a>
                                        case 'یوتیوب':
                                            return <a key={index} className="btn btn-sm-square bg-white text-primary me-1" href={row.value}><i className="fab fa-youtube"></i></a>
                                    
                                        default:
                                            return <div key={index}></div>
                                    }
                                } else {
                                    return ""
                                }
                            }
                        )}
                    </div>
                </div>
            </div>
        </div>


        <nav className="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0">
            <Link to="/" className="navbar-brand d-flex align-items-center px-4 px-lg-5">
                {logo ? <img src={logo} alt='logo' height={50}></img> : <h2 className="m-0 text-primary">{name}</h2>}
            </Link>
            <button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
                <div className="navbar-nav ms-0 p-4 p-lg-0">
                    {menu && menu.map((row,index) => 
                        <div key={index}> 
                        {row.value.includes("#") ? 
                            <HashLink className="nav-item nav-link" to={`/${row.value}`} data-animate="scrolling">{row.key}</HashLink>
                        :
                            <NavLink className="nav-item nav-link" to={row.value} end caseSensitive>{row.key}</NavLink>
                        }
                        </div>
                    )}
                </div>
                <HashLink to="/#contact" className="btn btn-primary py-4 px-lg-5 d-none d-lg-block ms-auto">پیام به ما<i className="fa fa-arrow-left ms-3"></i></HashLink>
            </div>
        </nav>
        </>
    )
}